export default {
  exceptionType: 'Exception Type',
  exceptionCode: 'Exception Code',
  productCode: 'Product Code',
  quantity: 'Quantity',
  sendToAntDate: 'Send To Ant Date'
}
